import { getNextPage, pageParams, retrieveFromStorage, saveToStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { USER_AUTHENTICATION_DATA } from "../User/types";
import { UPDATE } from "./types";

const api = new Api();

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};


export const updateRecords = (data = {}) => {
	let page = getNextPage(data);
	return async (dispatch) => {
		dispatch({ ...data, type: UPDATE, loading: true })
		// ${ page ? "/?page="+page : "/" }
		const res = await api.get({ endpoint: `users/${user?.username}/appointments/`, data: { page: page || 1, statuses: ["ACCEPTED","COMPLETED","DECLINED","REJECTED"] } });
		const _pageData = pageParams(res);
		if(res?.results) dispatch({ ...res, ..._pageData, type: UPDATE, loading: false })
	}
};

export const updateAppointsFilters = (data = {}) => {
	return { ...data, type: UPDATE };
};
